import { screen, within } from '@testing-library/react';

export const PageRenderHelpers = {
  getPageTitle: () => screen.getByTestId('page-title'),
  getPageHeader: () => screen.getByTestId('page-header'),
  getPageSearch: () => screen.getByTestId('page-search'),
  getPageSearchField: () => screen.getByTestId('page-search-field'),
  getPageMeta: () => screen.getByTestId('page-meta'),
  getPageAddButton: () => screen.queryByTestId('page-create-button'),
};

export const TableRenderHelpers = {
  /**
   * Get table container
   */
  getTableContainer: () => screen.getByTestId('table-card'),
  /**
   * Returns all rows of table, including the header row
   * @param container table container
   */
  getRows: (container: () => HTMLElement) => {
    const { getAllByRole } = within(container());
    return getAllByRole('row');
  },
  /**
   * Returns table header row
   */
  getHeader: (container: () => HTMLElement) => {
    const { getAllByRole } = within(container());
    return getAllByRole('row')[0];
  },

  getTableEmptyContainer: () => screen.queryByTestId('empty-container'),
};

export const DrawerRenderHelpers = {
  getDrawerContainer: () => screen.getByTestId('drawer-drawer'),
  getDrawerTitle: () => screen.getByTestId('drawer-title'),
  getDrawerSubtitle: () => screen.queryByTestId('drawer-subtitle'),
  getDrawerHeader: () => screen.getByTestId('drawer-header'),
  getDrawerMeta: () => screen.getByTestId('drawer-meta'),
  getDrawerActive: () => screen.queryByTestId('drawer-active'),
  getDrawerContent: () => screen.getByTestId('drawer-content'),
  getDrawerFooter: () => screen.getByTestId('drawer-footer'),
  getDrawerSave: () => screen.getByTestId('drawer-save'),
  getDrawerDeactivate: () => screen.queryByTestId('drawer-deactivate'),
  getDrawerActivate: () => screen.queryByTestId('drawer-activate'),
  getDrawerLoader: () => screen.queryByTestId('drawer-loader'),
};
